<template>
  <el-dialog
    :close-on-click-modal="false"
    title="添加油卡"
    :lock-scroll="true"
    :visible.sync="dialogFormVisible"
  >
    <section v-loading="getDetailLoading">
      <qx-custom-form
        @sub="sub"
        :noSubBtn="true"
        ref="customForm"
        :formData="formData"
      />
    </section>
    <section slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button
        type="primary"
        @click="customFormPost"
        :loading="subLoading || getDetailLoading"
        >确 定</el-button
      >
    </section>
  </el-dialog>
</template>

<script>
export default {
  data () {
    return {
      getDetailLoading: false, // 获取详情loading
      dialogFormVisible: false,
      subLoading: false, // 提交loading
      type: '', // add/新增 edit/修改
      merLoading: false, // 商户选项loading中
      originData: {},
      formData: {
        form: [
          {
            label: '油卡号',
            value: 'oilCardNum',
            type: 'input',
            default: '',
            placeholder: '请输入油卡号',
          },
        ],
        rules: {
          oilCardNum: [
            { required: true, message: '请输入油卡号', trigger: 'blur' },
          ],
        },
      },
    };
  },
  methods: {

    /**
     * @param {Object} item 修改的项
     * @returns {void}
     * @description 打开弹窗并初始化数据
     */
    show (item) {
      this.dialogFormVisible = true; // 打开弹窗
      if (this.$refs.customForm) {
        this.$refs.customForm.reset();
      }
    },

    hide () {
      this.dialogFormVisible = false;
    },

    customFormPost () {
      this.$refs.customForm.sub();
    },

    /**
     * @param {Object} form 表单数据
     * @returns {void}
     * @description 弹窗确定按钮事件
     */
    async sub (form) {
      this.subLoading = false;
      this.$emit('sub', {
        oilCardNum: this.$refs.customForm.getVal('oilCardNum'),
      });
    },
  },
};
</script>

<style>
</style>
